import React from "react";
import { Box, CardMedia, Typography } from "@mui/material";
import { keyframes } from "@emotion/react";
import logo from "../imgs/wandr-logo.svg";

const logoPulse = keyframes`
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.08);
  }
`;

const LogoLoader = ({ label = "Cargando...", minHeight = 220 }) => {
  return (
    <Box
      sx={{
        minHeight,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 1.4,
      }}
    >
      <CardMedia
        component="img"
        image={logo}
        alt="Wandr"
        sx={{
          width: 78,
          height: 78,
          filter: "drop-shadow(0 0 18px rgba(34, 197, 94, 0.45))",
          animation: `${logoPulse} 1.2s ease-in-out infinite alternate`,
        }}
      />
      <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 700 }}>
        {label}
      </Typography>
    </Box>
  );
};

export default LogoLoader;
